export function statementDescription(document: any) {
  if(!document) return '';
  let description = '';
  switch (document.type) {
    case 'invoice':
      description = 'Invoice ' + document._id;
      break;

    case 'Debit Note':
      description = 'Debit Note';
      break;
  
    case 'Credit Note':
      description = 'Credit Note';
      switch (document.subtype) {
        case 'Customer Discount':
          if(!document.invoice && document.discountType == 'Discount') {
            description = description +' - General Discount';
          } else {
            description = `${description} - ${document.discountType}`
          }
          break;
        
        case undefined:
          break;
        
        default:
          description = `${description} - ${document.subtype}`;
          break;
      }
      description = `${description} ${document.typeId}`;
      break;
    
    case 'misc':
      description = 'Miscellaneous Invoice';
      break;

    default:
      description = `${document.type} Payment ${document.invoicePaymentReceipt}`;
      break;
  }
  if(document.invoice) {
    description = `${description} for Invoice# ${document.invoice}`;
  }
  if(document.proformaInvoice) {
    description = `${description} for Proforma Invoice# ${document.proformaInvoice}`;
  }
  return description;
}